<template>
  <v-dialog
    v-model="recipientDialog"
    persistent
    hide-overlay
    max-width="800px"
    transition="dialog-center-transition"
    lazy
  >
    <v-card>
      <v-toolbar dark color="#A377FF">
        <v-toolbar-title class="m-0 white--text"
          >Dados do Recebedor</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="setRecipientDialog(false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline"
                >{{ type === "new" ? "Adicionar" : "Editar" }} Recebedor</span
              >
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-radio-group
                      v-model="personType"
                      row
                      :rules="[
                        (v) => !!v || 'Por favor, informe o tipo de pessoa!',
                      ]"
                      :disabled="type === 'edit'"
                      required
                    >
                      <v-radio label="Pessoa Física" value="pf"></v-radio>
                      <v-radio label="Pessoa Jurídica" value="pj"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="docNumber"
                      :label="personType === 'pf' ? 'CPF' : 'CNPJ'"
                      :mask="
                        personType === 'pf'
                          ? '###.###.###-##'
                          : '##.###.###/####-##'
                      "
                      :rules="
                        personType === 'pf'
                          ? [
                              (v) => !!v || 'Por favor, informe o CPF.',
                              (v) => v.length === 11 || 'O CPF não é válido!',
                            ]
                          : [
                              (v) => !!v || 'Por favor, informe o CNPJ.',
                              (v) => v.length === 14 || 'O CNPJ não é válido!',
                            ]
                      "
                      :disabled="type === 'edit'"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-autocomplete
                      v-model.lazy="bankCode"
                      label="Código do Banco"
                      :items="banks"
                      :item-text="bankText"
                      item-value="value"
                      :rules="[
                        (v) => !!v || 'Por favor, selecione o código do Banco!',
                      ]"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm5 md5>
                    <v-text-field
                      v-model="agency"
                      label="Agência"
                      type="number"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o código da agência.',
                        (v) =>
                          v.length === 4 || 'O código da agência não é válido!',
                      ]"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm2 md2 />
                  <v-flex xs12 sm5 md5>
                    <v-text-field
                      v-model="agencyDv"
                      label="Dígito da agência"
                      type="number"
                    />
                  </v-flex>
                  <v-flex xs12 sm5 md5>
                    <v-text-field
                      v-model="account"
                      label="Conta"
                      type="number"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o número da conta.',
                        (v) =>
                          v.length >= 5 || 'O número da conta não é válido!',
                      ]"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm2 md2 />
                  <v-flex xs12 sm5 md5>
                    <v-text-field
                      v-model="accountDv"
                      label="Dígito da conta"
                      type="number"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o número da conta.',
                        (v) =>
                          v.length === 1 || 'O dígito da conta não é válido!',
                      ]"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm5 md5>
                    <v-autocomplete
                      v-model.lazy="typeAccount"
                      label="Tipo de Conta"
                      :items="typeAccountList"
                      item-text="key"
                      item-value="value"
                    />
                  </v-flex>
                  <v-flex xs12 sm2 md2 />
                  <v-flex xs12 sm5 md5>
                    <v-text-field
                      label="Nome/Razão social do dono da conta bancária"
                      v-model="name"
                      maxLength="30"
                      hint="Máximo 30 caracteres"
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, digite o Nome/Razão social do dono da conta bancária',
                      ]"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md9>
                    <v-radio-group
                      v-model="transferInterval"
                      label="Período de Transferência"
                      row
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, informe o período de transferência',
                      ]"
                      required
                    >
                      <v-radio label="Diário" value="daily"></v-radio>
                      <v-radio label="Semanal" value="weekly"></v-radio>
                      <v-radio label="Mensal" value="monthly"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-select
                      v-model.lazy="transferDay"
                      label="Dia da Transferência"
                      :items="Array.from({ length: 30 }, (_, i) => i + 1)"
                      :rules="[
                        (v) =>
                          !!v || 'Por favor, selecione o dia da transferência!',
                      ]"
                      required
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn color="success" flat @click="validate()" :loading="loading"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import banksFile from "@/model/banco_codigo.json";

export default {
  props: {
    type: {
      type: String,
      default: "new",
    },
    partnerId: {
      type: String,
      default: null,
    },
    accounts: {
      type: Array,
      default: () => [],
    },
    recipient: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    rules: [],
    banks: banksFile,
    valid: false,
    loading: false,
    personType: "pf",
    typeAccount: "",
    bankCode: "",
    transferInterval: "",
    name: "",
    docNumber: "",
    agency: "",
    agencyDv: "",
    account: "",
    accountDv: "",
    transferDay: "",
    typeAccountList: [
      { key: "Conta corrente", value: "conta_corrente" },
      { key: "Conta corrente conjunta", value: "conta_corrente_conjunta" },
      { key: "Poupança", value: "conta_poupanca" },
      { key: "Poupança conjunta", value: "conta_poupanca_conjunta" },
    ],
  }),

  computed: {
    ...mapState("configuration", ["recipientDialog"]),
    ...mapGetters("configuration", ["partnerById"]),
  },

  methods: {
    ...mapActions("configuration", [
      "addRecipient",
      "changeRecipient",
      "updateRecipientsList",
    ]),
    ...mapMutations("configuration", ["setRecipientDialog"]),

    bankText(item) {
      return `${item.value} - ${item.label}`;
    },

    buttonDisable() {
      return (
        !this.valid ||
        this.personType.trim() === "" ||
        this.bankCode.trim() === "" ||
        this.name.trim() === "" ||
        this.transferInterval.trim() === "" ||
        this.docNumber.trim() === "" ||
        this.agency.trim() === "" ||
        this.account.trim() === "" ||
        this.accountDv.trim() === "" ||
        this.transferDay.trim() === "" ||
        this.loading
      );
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const bankAccountData = {
          bankCode: this.bankCode,
          agency: this.agency,
          agencyDv: this.agencyDv,
          typeAccount: this.typeAccount,
          account: this.account,
          accountDv: this.accountDv,
          docNumber: this.docNumber,
          name: this.name,
        };
        const recipientData = {
          transferInterval: this.transferInterval,
          transferDay: this.transferDay,
          bankAccountData,
        };
        const partnerData = {
          partnerId: this.partnerId,
          bankAccounts: this.accounts.map((account) => account), // Necessário criar uma cópia do array, pois senão ele altera o estado no VUEX
        };
        const recipientId = this.type === "edit" ? this.recipient.id : null;

        if (this.type === "new") {
          await this.addRecipient({ data: recipientData, ...partnerData });
        } else if (this.type === "edit") {
          await this.changeRecipient({ recipientId, data: recipientData });
          await this.updateRecipientsList({ recipientId });
        }
        this.$emit("updateList");
        this.loading = false;
      }
      this.setRecipientDialog(false);
    },
  },

  mounted() {
    if (this.type === "edit") {
      this.typeAccount = this.recipient.bank_account.type ?? "";
      this.personType =
        this.recipient.bank_account.document_type === "cpf" ? "pf" : "pj";
      this.bankCode = this.recipient.bank_account.bank_code;
      this.name = this.recipient.bank_account.legal_name;
      this.docNumber = this.recipient.bank_account.document_number;
      this.agency = this.recipient.bank_account.agencia;
      this.agencyDv = this.recipient.bank_account.agencia_dv ?? "";
      this.account = this.recipient.bank_account.conta;
      this.accountDv = this.recipient.bank_account.conta_dv;
      this.transferInterval = this.recipient.transfer_interval;
      this.transferDay = this.recipient.transfer_day;
    }
  },
};
</script>
